import { v4 as uuidv4 } from 'uuid';
import type { CardProps } from 'src/notifications/cardTypes';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';
import { formatFileSize } from 'src/utils/fileSizeFormatting';

export default function DetectionCompleteCard({
  notification,
  payload,
  onClose,
}: CardProps<'UPLOAD_DETECTION_COMPLETE'>) {
  const failed = payload.status === 'FAILED';

  return (
    <NotificationCardShell
      notification={notification}
      title={failed ? 'Upload could not be processed' : 'Upload processed'}
      body={
        failed
          ? 'We could not process your uploaded document.'
          : 'Your uploaded document has finished processing.'
      }
      clientId={payload.client_id}
      details={
        <>
          {payload.file_name && <NotificationDetailRow label="File" value={payload.file_name} />}
          {payload.file_size != null && (
            <NotificationDetailRow label="Size" value={formatFileSize(payload.file_size)} />
          )}
        </>
      }
      actions={
        <>
          <NotificationLinkButton
            to={`/client/${payload.client_id}/document/add`}
            onClose={onClose}
          >
            View
          </NotificationLinkButton>
          {!failed && (
            <NotificationLinkButton
              primary
              to={`/client/${payload.client_id}/detected-entities?fileId=${payload.file_id}&fileName=${encodeURIComponent(payload.file_name ?? '')}&guid=${uuidv4()}`}
              onClose={onClose}
            >
              Process
            </NotificationLinkButton>
          )}
        </>
      }
    />
  );
}
